import { useQuery } from "react-query";
import { fetchOneById } from "api/FacilityApi";
import { facilityQueryKeys } from "queries/constants";
import { QueryOptions } from "queries/queries";
import { useToast } from "components/common/ui/toast/useToast";

export const useFacilityDetail = (
  facilityId: string,
  options?: QueryOptions
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    facilityQueryKeys.detail(facilityId),
    () => fetchOneById(facilityId),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load facility details", {
          id: facilityQueryKeys.detail(facilityId).join("::"),
        }),
      staleTime: 60 * 1000,
      ...options,
    }
  );
};
